



















































































































import { Vue, Component, Watch } from "vue-property-decorator";
import AuthApi from "@/general/api/authApi";
import ModalMain from "@/common/components/organisms/ModalMain.vue";
import IconCheck from "@/common/components/icons/IconCheck.vue";
import CONST_DATA from "@/general/mixins/const/constData";
import { Company, UserInfo, Account, SelectLoginGroup } from "@/general/store/models";
import auth, { AuthState } from "@/general/store/modules/auth";
import LocalStorage from "@/general/utils/storage";
import commons from "@/common/store/modules/commons";
import Cookies from "js-cookie";
import CONST from "@/general/mixins/const/constData";
import { karteLogin } from "@/common/assets/js/karte/";
import loginInfo from "@/general/store/modules/loginInfo";

@Component({
  components: {
    ModalMain,
    IconCheck
  }
})
export default class AuthenticationCallback extends Vue {
  companyCd: string;
  companyList: Company[] = [] as Company[];
  users: UserInfo = {} as UserInfo;
  showModalSupplier = false;
  showModalGroup = false;
  process = false;
  isLoading = true;
  mailAddress: string;
  accountList: Account[] = [] as Account[];
  groupList: SelectLoginGroup[] = [] as SelectLoginGroup[];
  subscriptions: string;
  boSrvCd: string;
  selectedId: string;
  selectedGroupId: number;
  selectedGroupName: string;
  checkColor: string;
  bsCustomerNumber: string = "";
  showSelectMode = false;
  selectedModeId: string = "";
  groupbudget: string = "groupbudget";
  general: string = "general";
  iss: string = "";
  sub: string = "";
  usingEmployeeId: string;
  ssoFlg = false;

  async created() {
    //ssoチェック用のパラメタ
    // ログアウトせずに別アカウントでログインした場合、前のユーザー情報を引き継いでしまうためストレージクリア
    // localStorage.clear();
    LocalStorage.removeAll();

    this.checkColor = "red";
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let ssocheck=urlParams.get('ssocheck');
    console.log("login start.");

    // SSOFLGの取得
    const bsffSessionResult = await AuthApi.getBsffSessionInfo();
    if ((bsffSessionResult as any)?.ssoFlg === true) {
      loginInfo.setSsoFlg(true);
    } else {
      loginInfo.setSsoFlg(false);
    }

    this.ssoFlg = loginInfo.isSso;

    await AuthApi.getUserContractInfo()
      .then((resLogin) => {
        console.log("resLogin", resLogin);
        console.log("resLogin.contractInfo", resLogin.contractInfo);
        const contractInfo = resLogin.contractInfo;
        const contractInfoLen = contractInfo.length;
        // customerNoの数で処理を変更
        if (contractInfoLen > 1 || ssocheck==='select') {
          for (let i = 0; i < contractInfoLen; i++) {
            this.accountList.push({
              id: contractInfo[i].customerNo,
              name: contractInfo[i].companyName
            });
            console.log("this.accountList", this.accountList);
          }
          // this.$refs.accountModal.show();
          // 暫定
          this.companyCd = contractInfo[0].companyCd;
          this.selectedId = contractInfo[0].customerNo;
          this.showModalSupplier = true;
        } else {
          console.log("contractInfo[0]", contractInfo[0]);
          this.bsCustomerNumber = contractInfo[0].customerNo;
          this.fetchGroupList();
          this.subscriptions = contractInfo[0].subscriptions;
          this.boSrvCd = contractInfo[0].subscriptions[0].boServiceCode;
          this.companyCd = contractInfo[0].companyCd;
          this.showModalSupplier = false;
        }

      })
      .catch((err) => {
        console.log(err);
        console.log("BFF:loginエラー");
        this.errorLogin();
      });

    // memo: getUserInfoCompanyListはコール不要（フィット対応がなくなったからとのこと）
    // const companyList: Company[] = await AuthApi.getUserInfoCompanyList();
    // if (!companyList) {
    //   window.location.href = CONST_DATA.SITE_MAP.DEFAULT;
    //   return;
    // }
    // this.companyList = companyList;

    // this.showModal = true;
    if (this.accountList && this.accountList.length > 0) {
      this.selectedAccount(this.accountList[0].id);
    }
    this.isLoading = false;
    if (!this.process) {
      // window.location.href = CONST_DATA.SITE_MAP.DEFAULT;
      // window.location.href = CONST_DATA.SITE_MAP.LOGIN;
      return;
    }
  }

  async fetchGroupList(){
    const groupList = await AuthApi.getSelectLoginGroup(this.bsCustomerNumber);
    this.groupList = groupList
    if(groupList.length == 0) {
      console.log("api/select_login_group: エラー")
      this.errorLogin();
      return;
    } else if(groupList.length == 1) {
      this.showModalGroup = false
      this.selectedGroupId = parseInt(this.groupList[0].group_id, 10)
      this.selectedGroupName = this.groupList[0].name
      const isModeSelect = await AuthApi.getModeSelect(this.bsCustomerNumber, this.selectedGroupId);
      this.showSelectMode = isModeSelect.modeSelect
      this.usingEmployeeId = isModeSelect.usingEmployeeId
      if(this.showSelectMode == false) {
        await this.userConfirm(this.bsCustomerNumber, this.iss, this.sub, this.selectedGroupId);
      }
    } else {
      this.showModalGroup = true
      this.selectedGroupId = parseInt(this.groupList[0].group_id, 10)
    }
  }

  async handleSelectCompany() {
    this.process = true;
    // await this.getUser();
    this.bsCustomerNumber = this.selectedId
    const groupList = await AuthApi.getSelectLoginGroup(this.bsCustomerNumber);
    this.groupList = groupList
    this.selectedGroupId = parseInt(this.groupList[0].group_id, 10)
    if(this.groupList.length == 0) {
      console.log("api/select_login_group: エラー")
      this.errorLogin();
      return;
    } else if(this.groupList.length == 1) {
      this.showModalGroup = false
      const isModeSelect = await AuthApi.getModeSelect(this.bsCustomerNumber, this.selectedGroupId);
      this.showSelectMode = isModeSelect.modeSelect
      this.usingEmployeeId = isModeSelect.usingEmployeeId
      if(this.showSelectMode == false) {
        await this.userConfirm(this.bsCustomerNumber, this.iss, this.sub, this.selectedGroupId);
      }
    } else {
      this.showModalGroup = true
      this.selectedGroupId = parseInt(this.groupList[0].group_id, 10)
    }

    this.closeModalSupplier();
  }

  async handleSelectGroup() {
    this.process = true;
    const isModeSelect = await AuthApi.getModeSelect(this.bsCustomerNumber, this.selectedGroupId);
    this.showSelectMode = isModeSelect.modeSelect
    this.usingEmployeeId = isModeSelect.usingEmployeeId
    const filteredSelectGroup = this.groupList.filter(obj => obj.group_id == this.selectedGroupId.toString())
    this.selectedGroupName = filteredSelectGroup[0].name
    this.selectedGroup();
    this.closeModalGroup();
    if(this.showSelectMode == false) {
      this.userConfirm(this.bsCustomerNumber, this.iss, this.sub, this.selectedGroupId);
    }
  }
  selectedAccount(id: string) {
    this.selectedId = id;
    console.log("this.selectedId,", this.selectedId);
    this.accountList.forEach((account) => {
      const accountButton = document.getElementById("btn-" + account.id);
      const accountCheck = document.getElementById("check-" + account.id);
      if (account.id == id) {
        accountButton?.classList.add("p-account-local__list__account--current");
        accountCheck?.classList.add("p-account-local__list__account--current__check");
        accountCheck?.classList.remove("p-account-local__list__account--current__check__none");
      } else {
        accountButton?.classList.remove("p-account-local__list__account--current");
        accountCheck?.classList.remove("p-account-local__list__account--current__check");
        accountCheck?.classList.add("p-account-local__list__account--current__check__none");
      }
    });
  }
  selectedGroup() {
    console.log("セレクトボックスで選ばれたID,", this.selectedGroupId);
  }

  closeModalSupplier() {
    this.showModalSupplier = false;
  }

  closeModalGroup() {
    this.showModalGroup = false;
  }

  async handleSelectMode(){
    if(this.selectedModeId == "groupbudget") {
      console.log("groupbudgetモード")
      const groupBudgetUser = await AuthApi.getGroupBudgetUserInfo(this.selectedGroupId);
      this.iss = groupBudgetUser.iss
      this.sub = groupBudgetUser.sub
      this.userConfirm(this.bsCustomerNumber, this.iss, this.sub, this.selectedGroupId);
    } else {
      console.log("一般モード")
      this.userConfirm(this.bsCustomerNumber, this.iss, this.sub, this.selectedGroupId);
    }
    this.closeSelectMode();
  }
  closeSelectMode(){
    this.showSelectMode = false;
  }

  async getUser() {
    console.log("getUser()");
    let userRead: UserInfo | any;

    userRead = await AuthApi.getUserInfoRead(this.companyCd);

    if (userRead == null || !userRead.user_id) {
      LocalStorage.removeAll();
      this.errorLogin();
      if (this.ssoFlg) {
        // SSOログイン時は行き止まりエラー画面へ
        // エラー画面表示用にSSOFLGをセットしなおし、エラー画面でFLGを改めて削除する
        loginInfo.setSsoFlg(true);
        window.location.href = "/session-time-out/";
      } else {
        const login_facade =
          process.env.VUE_APP_AUTH_FACADE +
          "?force_re_authentication=TRUE&callback_authorization_start_uri=" +
          process.env.VUE_APP_API_DOMAIN +
          "/v1/top/auth-start";
        window.location.href = login_facade;
        return;
      }
    }

    console.log({ userRead });

    //    const userRead: UserInfo = await AuthApi.getUserInfoRead(this.companyCd);
    const payload: AuthState = {} as AuthState;
    this.users = userRead;
    payload.user = this.users;
    payload.authenticate = true;
    if (userRead) {
      auth.setUser(payload);
      auth.setAuthentication(payload);
    }
    await AuthApi.putLastLoginUpdate(this.users.user_id);

    await this.handleOrgPageSpecific();
    await this.handleTempOrgAdminSetting();
    setTimeout(() => {
      window.location.href = CONST_DATA.SITE_MAP.TOP_PAGE;
    }, 1000);
  }

  @Watch("process")
  redirectTo() {
    if (!this.process) {
      window.location.href = CONST_DATA.SITE_MAP.DEFAULT;
    }
  }

  async userConfirm(customerNo: string, iss: string|null, sub: string|null, groupId: number) {
    this.isLoading = true;
    const params = new URLSearchParams();
    params.append("customerNo", customerNo);
    params.append("iss", iss !== null ? iss : '');
    params.append("sub", sub !== null ? sub : '');
    params.append("groupId", groupId.toString());
    /*
    const params = {
      customerNo: customerNo
    };
    */

    const updateUserResult = await AuthApi.updateUser(params);
    try {
      // 認可対応
      console.log(updateUserResult);
      console.log(updateUserResult.isAuthorized);
      if (updateUserResult.isAuthorized === false) {
        this.logoutNoRedirect();
        if (this.ssoFlg) {
          // SSOログイン時は行き止まりエラー画面へ
          window.location.href = "/session-time-out/";
        } else {
          const authError = process.env.VUE_APP_IC_DOMAIN + "/not-available/";
          window.location.href = authError;
        }
        return;
      }
    } catch (e) {
      // nothing to do
    }
    if (updateUserResult.isError) {
      console.log("BFF:ユーザー情報更新エラー", updateUserResult);
      LocalStorage.removeAll();
      this.errorLogin();
      return;
    }

    await this.getUser();

    if (updateUserResult.isCompleteFirstLogin) {
      // ユーザー情報取得
      const postUserResult = await AuthApi.postUser();
      if (postUserResult.isError) {
        console.log("/v1/users/my: エラー", postUserResult);
        this.errorLogin();
        return;
      }

      this.finishLogin(postUserResult);
    } else {
      // 初回モーダル表示
      // this.$refs.firstLoginModal.show();
      this.isLoading = false;
    }
  }

  async submit(e: any) {
    this.isLoading = true;
    const params = {
      isSubscribe: e.isSubscribe
    };

    // 初回ログイン完了API実行
    const putCompleteResult = await AuthApi.putComplete(params);
    if (putCompleteResult.isError) {
      console.log("初回ログイン完了エラー", putCompleteResult);
      this.errorLogin();
      return;
    }

    // ユーザー情報取得
    const postUserResult = await AuthApi.postUser();
    if (postUserResult.isError) {
      console.log("/v1/users/my：エラー");
      this.errorLogin();
      return;
    }
    this.finishLogin(postUserResult);
  }
  hide() {
    this.closeModalSupplier();
    // 戻り先用のクッキー削除
    document.cookie = this.createSetCookie("back_uri", "", new Date(0));
    this.deleteUserCookie();
    auth.remove();
    this.isLoading = false;
    if (this.ssoFlg){
      // SSOログイン時は行き止まりログアウト画面へ
      window.location.href = "/logout/";
    } else {
      location.href = process.env.VUE_APP_API_DOMAIN + "/v1/top/login";
    }
  }
  // ログインが完了した場合の共通処理
  async finishLogin(data: any) {
    Cookies.set("auth-user", data);
    // 戻り先用のクッキー削除
    document.cookie = this.createSetCookie("back_uri", "", new Date(0));
    // this.$auth.init("", "", data, this.subscriptions);
    auth.initSubscription(data, this.subscriptions);

    // 利用可能補助金の取得
    // let params = {};
    // const subsidy = await this.$repositories(
    //   "subsidy"
    // ).getSubsidyAvailableLogin(params);
    // this.$store.commit("subsidy/setSubsidy", subsidy.data);
    // this.$store.commit("subsidy/remove");
    // this.$store.dispatch("subsidy/getSubsidy");
    console.log(data);
    this.$store.commit("auth/setSsoPrincipalFlg", {
      payload: data?.ssoPrincipalFlg
    });
    this.isLoading = false;
    const currentHref = LocalStorage.getItem("currentHref");
    let backUri = "";
    if (currentHref) {
      backUri = decodeURIComponent(currentHref).replace(/\/\?back_uri=/, "");
    } else {
      backUri = CONST.SITE_MAP.TOP_PAGE;
    }
    LocalStorage.setItem("currentHref", "");    
    location.href = backUri;

    // const backUri = func_utils.getCurrentHref();
    // func_utils.gotoBackURI(backUri);
    // this.$router.push({
    //   path: backUri
    // });
  }
  errorLogin() {
    this.deleteUserCookie();
    // 戻り先用のクッキー削除
    document.cookie = this.createSetCookie("back_uri", "", new Date(0));
    this.isLoading = false;
    // エラー画面へ遷移
    // this.$router.push("error");
    this.logout();
  }
  deleteUserCookie() {
    document.cookie = this.createSetCookie("bsBenefitOneInc", "", new Date(0));
  }
  createSetCookie(name: string, value: string, expires: Date) {
    const expires_ = expires
      ? "expires=" +
        (expires instanceof Date
          ? expires
          : new Date(Date.now() + Number.parseInt(expires))
        ).toUTCString()
      : "";
    // userInfoの時はcookieがリクエストヘッダーに付くように属性を設定
    const addSameSite =
      name === "userInfo"
        ? "domain=" +
          process.env.VUE_APP_COOKIE_DOMAIN +
          "; SameSite=none; Secure"
        : "";
    return [`${name}=${value || ""}`, expires_, "path=/", addSameSite].join(
      "; "
    );
  }

  async handleOrgPageSpecific() {
    const {
      organization_id,
      page_title,
      page_logo,
      page_color,
      point_name,
      point_logo,
      favicon,
      default_thanks_message
    } = this.users;

    const OrgPageSpecific = {
      // #59042対応によりpage_logo、point_logo、faviconをローカルストレージ上に保存しないように修正
      organization: organization_id,
      page_title: page_title,
      //page_logo: page_logo,
      page_color: page_color,
      point_name: point_name,
      //point_logo: point_logo,
      //favicon: favicon,
      default_thanks_message: default_thanks_message
    };

    LocalStorage.setItem("OrgSpecificData", JSON.stringify(OrgPageSpecific));
  }

  async handleTempOrgAdminSetting() {
    const user = this.users;
    const orgAdminSettings = [
      {
        id: 32,
        organization: user.organization_id,
        number_of_users_to_register: 1000,
        user_usage_start_date: "2021-12-16",
        site_id: user.slug,
        number_of_months: 24,
        point_expiry_time_period: 0,
        display_email_address: 1,
        email_address: user.email,
        display_telephone_number: 1,
        telephone_number: user.tel,
        display_department_name: 0,
        department_name: "試験部",
        enquiry_of_product:
          process.env.VUE_APP_BS_DOMAIN + "/contents/cgi/memberfaqic/index.html",
        source_representation_of_delivery_mails: 0,
        special_notes:
          "ポイントには有効期限がございます。 有効期限は「ポイント確認」よりご確認ください。",
        grant_exclusive_point_enabled: 1,
        grant_expiry_number_of_months: 12,
        grant_expiry_time_period: 1,
        thanks_point_enabled: user.thanks_point_enabled,
        thanks_point_pattern: 3,
        points_to_send: 1000,
        max_points: 200,
        min_points: 0,
        point_giving_range: 1,
        thread_enabled: user.thread_enabled,
        thanks_point_approval_enabled: user.thanks_point_approval_enabled,
        thanks_exclusive_points_enabled: user.thanks_exclusive_points_enabled,
        allow_points_regifting: user.allow_points_regifting,
        thanks_point_arrived_notification_enabled: 1,
        approval_result_notification_mail:
          user.approval_result_notification_mail,
        approval_pending_count_notification_mail:
          user.approval_pending_count_notification_mail,
        thanks_expiry_number_of_months: 10,
        thanks_expiry_time_period: 1,
        self_pay_enabled: user.self_pay_enabled,
        point_course_category: "01",
        taxation_category: user.taxation_category,
        payment_method: 0,
        payment_period: 0,
        payment_period_in_months: null,
        payment_due_date: 0,
        others_payment_due_date: null,
        service_usage_fee: 0,
        service_usage_fee_for_other: null,
        point_receipt_notification_enabled: 1,
        point_balance_notification_enabled: 0,
        point_expiry_notification_enabled: 1,
        apply_confirmation_mail_enabled: user.apply_confirmation_mail_enabled,
        mail_magazine_enabled: 1,
        password_reset_request_function: 1,
        created_by: null,
        updated_by: null,
        created_at: "2021-12-16T09:34:51.042919Z",
        updated_at: "2022-11-29T10:57:10.388209Z",
        latest_transaction: 0,
        grant_point_delete_notification_mail: 1,
        membership_term_url: null,
        footer_membership_url:
          "https://icpt-ric.tst.benefit-one.inc/static/profiles/files/standard_agreement.docx",
        membership_agreement: 0,
        point_revocation_notification: 0,
        gift_notification_mail_usability: 1,
        sunkus_dedicated_point_usability: 1,
        approval_function_usability: user.approval_function_usability,
        need_to_use_thread_usability: 1,
        point_gifting_range: 1,
        sunkus_point_deadline: 1,
        sunkus_dedicated_point_gift_deadline_4: null,
        sunkus_dedicated_point_gift_deadline_3: null,
        sunkus_dedicated_point_gift_deadline_2: null,
        sunkus_dedicated_point_gift_deadline_1: null,
        fixed_point: null,
        dead_line_for_gathering: 1,
        dedicated_points_deadline_entry_4: null,
        dedicated_points_deadline_entry_3: 1,
        dedicated_points_deadline_entry_2: 1,
        dedicated_points_deadline_entry_1: 1,
        initial_registration_fee: "1.00",
        pinning: null,
        service_usage_fee_price_10000: null,
        service_usage_fee_price_5001_to_10000: null,
        service_usage_fee_price_1001_to_5000: null,
        service_usage_fee_rate_101_to_1000: null,
        service_usage_fee_rate_1_to_100: null,
        service_usage_pattern: 0,
        balance_acquisition_api_usability: 0,
        grant_api_usage: 0,
        file_linkage_cost: null,
        file_linkage_usability: 0,
        point_jpy_rate: 1,
        tax_difference: 1,
        thanks_exclusive_points_invoice_flag: 0,
        thanks_expiry_term_period: null,
        grant_expiry_term_period: null,
        normal_expiry_term_period: null,
        sso_use_cost: null,
        grant_api_cost: null,
        balance_api_cost: null,
        sso_function_usability: user.sso_function_usability,
        company_code: user.company_code,
        bpf_invoice_output_flag: 1,
        invoice_output_flag: 0,
        monthly_batch_grant_flag: false,
        grant_exclusive_points_invoice_flag: 0
      }
    ];
    // #59042対応によりpage_logo、point_logo、favicon、avatar、rankImagePc、rankImageSpをローカルストレージ上に保存しないように修正
    LocalStorage.setItem("orgAdminSettings", JSON.stringify(orgAdminSettings));
    delete this.users.page_logo;
    delete this.users.point_logo;
    delete this.users.favicon;
    delete this.users.avatar;
    delete this.users.rankImagePc;
    delete this.users.rankImageSp;

    LocalStorage.setItem("userDetails", JSON.stringify(this.users));
  }
  async logout() {
    try {
      this.logoutNoRedirect();
    } catch (e) {
      // no ope
    } finally {
      if (this.ssoFlg) {
        // SSOログイン時は行き止まりエラー画面へ
        // エラー画面表示用にSSOFLGをセットしなおし、エラー画面でFLGを改めて削除する
        loginInfo.setSsoFlg(true);
        window.location.href = "/session-time-out/";
      } else {
        const authError = process.env.VUE_APP_IC_DOMAIN + "/not-available/";
        window.location.href = authError;
      }
    }
  }
  async logoutNoRedirect() {
    try {
      karteLogin(false);

      let cookieName = "BSJSESSIONID";
      if (process.env.VUE_APP_SESSION_COOKIE_NAME) {
        cookieName = process.env.VUE_APP_SESSION_COOKIE_NAME;
      }
      let cookieDomain = ".benefit-one.inc";
      if (process.env.VUE_APP_COOKIE_DOMAIN) {
        cookieDomain = process.env.VUE_APP_COOKIE_DOMAIN;
      }
      console.log("delete cookie name." + cookieName);
      //document.cookie = `${cookieName}=;domain=${cookieDomain};path=/;`;
      Cookies.remove(cookieName);
      await fetch(commons.LOGOUT_URL, { method: "POST" })
        .then(() => {
          window.sessionStorage.clear();
          // window.localStorage.clear();
          LocalStorage.removeAll();
          AuthApi.getLogout();
          auth.remove();
        })
        .catch(() => {
          window.sessionStorage.clear();
          // window.localStorage.clear();
          LocalStorage.removeAll();
          AuthApi.getLogout();
          auth.remove();
        });
    } catch (e) {
      // no ope
    }
  }
}
